import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/pro-solid-svg-icons';
import { faSort as faSortDuoTone } from '@fortawesome/pro-duotone-svg-icons';

import PropTypes from 'prop-types';
/* istanbul ignore next */
function SortableTableHeader({
  onAscClick, onDescClick, label, isSelected,
}) {
  const [sortOrder, setSortOrder] = useState('');

  const handleAscClick = (e) => {
    setSortOrder('ASC');
    onAscClick(e);
  };

  const handleDescClick = (e) => {
    setSortOrder('DES');
    onDescClick(e);
  };

  const handleLabelClick = (e) => {
    if (!sortOrder || sortOrder === 'DES') {
      handleAscClick(e);
    } else if (sortOrder === 'ASC') {
      handleDescClick(e);
    }
  };

  const getIconToggleStatus = () => {
    if (isSelected && sortOrder === 'ASC') {
      return <FontAwesomeIcon icon={faSortDuoTone} />;
    }
    if (isSelected && sortOrder === 'DES') {
      return <FontAwesomeIcon icon={faSortDuoTone} style={{ transform: 'rotate(180deg)' }} />;
    }
    return <FontAwesomeIcon icon={faSort} className="text-muted" />;
  };

  return (
    <th
      className="text-left pl-1 pr-1"
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
      }}
      >
        <button
          type="button"
          className="btn btn-sm shadow-none pl-0"
          onClick={handleLabelClick}
        >
          {getIconToggleStatus()}
        </button>
        <span onClick={handleLabelClick} style={{ cursor: 'pointer' }}>
          {label}
          {' '}
        </span>
      </div>
    </th>
  );
}

SortableTableHeader.propTypes = {
  onAscClick: PropTypes.func.isRequired,
  onDescClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default SortableTableHeader;
